import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

// services
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';
import { VisitsService } from './visits.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class VisitsServiceModule {
  static forRoot(): ModuleWithProviders<VisitsServiceModule> {
    return {
      ngModule: VisitsServiceModule,
      providers: [VisitsService],
    };
  }
}
